// Thermal Expansion units with conversion factors to per-kelvin (1/K)
export const thermalExpansionUnits = [
  { id: 'per-kelvin', name: 'Per Kelvin', symbol: '1/K', plural: 'Per Kelvin', toBase: 1 },
  { id: 'per-degree-celsius', name: 'Per Degree Celsius', symbol: '1/°C', plural: 'Per Degree Celsius', toBase: 1 },
  { id: 'per-degree-fahrenheit', name: 'Per Degree Fahrenheit', symbol: '1/°F', plural: 'Per Degree Fahrenheit', toBase: 1.8 },
  { id: 'per-degree-rankine', name: 'Per Degree Rankine', symbol: '1/°R', plural: 'Per Degree Rankine', toBase: 1.8 },
  { id: 'per-degree-reaumur', name: 'Per Degree Reaumur', symbol: '1/°Ré', plural: 'Per Degree Reaumur', toBase: 0.8 },
];

export const popularThermalExpansionConversions = [
  { from: 'per-kelvin', to: 'per-degree-celsius' },
  { from: 'per-degree-celsius', to: 'per-kelvin' },
  { from: 'per-kelvin', to: 'per-degree-fahrenheit' },
  { from: 'per-degree-fahrenheit', to: 'per-kelvin' },
  { from: 'per-degree-celsius', to: 'per-degree-fahrenheit' },
  { from: 'per-degree-fahrenheit', to: 'per-degree-celsius' },
];

export const getUnitById = (id) => thermalExpansionUnits.find(unit => unit.id === id);

export const convertThermalExpansion = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.toBase;
  return baseValue / toUnit.toBase;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert thermal expansion coefficient units and learn the conversion formula.`;
};
